import { createContext, useContext, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./HomeworkReportUIHelpers";

const HomeworkReportUIContext = createContext();

export function useHomeworkReportUIContext() {
  return useContext(HomeworkReportUIContext);
}

export const HomeworkReportUIConsumer = HomeworkReportUIContext.Consumer;

export function HomeworkReportUIProvider({ children }) {
  const { user } = useSelector(state => state.auth);
  initialFilter.term = user.currentActiveTerm; // Mevcut Aktif Dönem Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams
  };

  return (
    <HomeworkReportUIContext.Provider value={value}>
      {children}
    </HomeworkReportUIContext.Provider>
  );
}